import React, { useEffect, useMemo, useState } from "react";
import { Paper, Typography, Divider, Grid } from "@material-ui/core";
import DataTable from "../../Components/DataTable";
import { Api } from "../../api/client";
import { num, money } from "../../utils/format";

export default function MasMenosVendidos(){

  const [data,setData]=useState([]);

  useEffect(()=>{
    async function load(){
      const r=await Api.productsRanking({});
      const list=Array.isArray(r)?r:(r?.data||[]);
      setData(list);
    }
    load();
  },[]);

  const top=data.slice(0,5);
  const bottom=data.slice(-5);

  const columns=[
    {key:"producto",label:"Producto"},
    {key:"cantidad",label:"Cantidad",render:r=>num(r.cantidad)},
    {key:"ingreso",label:"Ingresos",render:r=>money(r.ingreso)}
  ];

  return (
    <Paper style={{padding:18,borderRadius:14}}>
      <Typography variant="h6" style={{fontWeight:900}}>Más y menos vendidos</Typography>
      <Divider style={{margin:"12px 0"}}/>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography style={{fontWeight:900}}>Top 5</Typography>
          <DataTable columns={columns} rows={top}/>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography style={{fontWeight:900}}>Bottom 5</Typography>
          <DataTable columns={columns} rows={bottom}/>
        </Grid>
      </Grid>
    </Paper>
  );
}